/**
 * @generated SignedSource<<786b8497ee103cf23ce8febbba01ffa7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type theoryEditMutation$variables = {
  backLang?: string | null;
  id: string;
  langNative?: string | null;
  theory?: string | null;
  theoryNative?: string | null;
};
export type theoryEditMutation$data = {
  readonly editTheories: {
    readonly back: {
      readonly translated: boolean | null;
      readonly value: string;
    } | null;
    readonly front: string;
    readonly hint: string | null;
    readonly id: string;
    readonly svg: {
      readonly flatId: string;
      readonly url: string;
    } | null;
    readonly theory: {
      readonly canEdit: boolean;
      readonly lang: string;
      readonly langNative: string;
      readonly sCardId: string;
      readonly theory: string;
      readonly theoryEn: string | null;
      readonly theoryIsChecked: boolean;
      readonly theoryNative: string;
      readonly theoryNativeIsChecked: boolean;
    } | null;
  } | null;
};
export type theoryEditMutation = {
  response: theoryEditMutation$data;
  variables: theoryEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "backLang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "langNative"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "theory"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "theoryNative"
},
v5 = [
  {
    "kind": "Variable",
    "name": "backLang",
    "variableName": "backLang"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "theory",
    "variableName": "theory"
  },
  {
    "kind": "Variable",
    "name": "theoryNative",
    "variableName": "theoryNative"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "front",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hint",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "langNative",
    "variableName": "langNative"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translated",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": (v9/*: any*/),
  "concreteType": "SCardTheory",
  "kind": "LinkedField",
  "name": "theory",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sCardId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theoryIsChecked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theoryNative",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theoryNativeIsChecked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theoryEn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lang",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "langNative",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEdit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flatId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "theoryEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SCard",
        "kind": "LinkedField",
        "name": "editTheories",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "SCardBack",
            "kind": "LinkedField",
            "name": "back",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Upload",
            "kind": "LinkedField",
            "name": "svg",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "theoryEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SCard",
        "kind": "LinkedField",
        "name": "editTheories",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "SCardBack",
            "kind": "LinkedField",
            "name": "back",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Upload",
            "kind": "LinkedField",
            "name": "svg",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b93bd8e24cee15c7d211eba3a47fabb",
    "id": null,
    "metadata": {},
    "name": "theoryEditMutation",
    "operationKind": "mutation",
    "text": "mutation theoryEditMutation(\n  $id: ID!\n  $theory: String\n  $theoryNative: String\n  $backLang: String\n  $langNative: String\n) {\n  editTheories(id: $id, theory: $theory, theoryNative: $theoryNative, backLang: $backLang) {\n    id\n    front\n    hint\n    back(langNative: $langNative) {\n      value\n      translated\n      id\n    }\n    theory(langNative: $langNative) {\n      sCardId\n      theory\n      theoryIsChecked\n      theoryNative\n      theoryNativeIsChecked\n      theoryEn\n      lang\n      langNative\n      canEdit\n    }\n    svg {\n      flatId\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0c15f1afc82070e31245a14e7c52edf";

export default node;
